import { render, staticRenderFns } from "./LayoutFixedCenter.vue?vue&type=template&id=cf11672a&scoped=true&"
import script from "./LayoutFixedCenter.vue?vue&type=script&lang=js&"
export * from "./LayoutFixedCenter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFixedCenter.vue?vue&type=style&index=0&id=cf11672a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf11672a",
  null
  
)

export default component.exports